import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/site";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="December 2025" testid="privacy-page">
      <p>
        This Privacy Policy explains how {COMPANY.name} ("Aumonline", "we", "us") handles
        information when you use our websites and software products (Kreta, Apoopika and Jigyasa).
        We keep this simple: we collect only what we need to run the Services, and we never sell
        your data.
      </p>

      <LegalSection heading="1. Information we collect">
        <p>
          <strong>Account information</strong> — such as your name, business name, email address
          and phone number, provided when you register.
        </p>
        <p>
          <strong>Business and customer records</strong> — the data you enter into a Service to run
          your business (for example customers, orders, tickets, enquiries, staff and inventory).
          This content belongs to you.
        </p>
        <p>
          <strong>Usage and device information</strong> — basic technical data such as log data and
          cookies, used to keep the Services secure and working.
        </p>
      </LegalSection>

      <LegalSection heading="2. How we use information">
        <p>
          We use information to provide and maintain the Services, to support you, to process
          subscriptions, to keep accounts secure, and to comply with legal obligations. We do not
          use your business or customer records for advertising.
        </p>
      </LegalSection>

      <LegalSection heading="3. We do not sell your data">
        <p>
          We never sell or rent your personal information or your business records to anyone. We
          share data only with service providers who help us operate the Services (for example
          hosting and payment processing), and only to the extent needed to deliver the Service.
        </p>
      </LegalSection>

      <LegalSection heading="4. Payments">
        <p>
          Subscription payments are handled by payment processors within each product. Card and
          banking details are processed by those providers under their own security standards; this
          website does not collect or store payment card information.
        </p>
      </LegalSection>

      <LegalSection heading="5. Cookies and analytics">
        <p>
          Our websites and products may use cookies and basic analytics to remember your session
          and understand how the Services are used, so we can improve them. You can control cookies
          through your browser settings.
        </p>
      </LegalSection>

      <LegalSection heading="6. Data storage and security">
        <p>
          Your data is stored with reputable hosting providers and protected with reasonable
          technical and organisational measures. No system is perfectly secure, but we take care to
          protect your information.
        </p>
      </LegalSection>

      <LegalSection heading="7. Data retention">
        <p>
          We keep your data for as long as your account is active. If you close your account, we
          delete or anonymise your data within a reasonable period, unless we must keep it to meet
          a legal obligation.
        </p>
      </LegalSection>

      <LegalSection heading="8. Your rights">
        <p>
          You may ask us to access, correct or delete your personal information. To make a request,
          email {COMPANY.email} and we will respond within a reasonable time.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contact for privacy questions">
        <p>
          For any privacy question or request, contact us at {COMPANY.email} or {COMPANY.phoneDisplay}.
          Our registered office is {COMPANY.addressLine1}, {COMPANY.addressLine2}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
